import React, { useContext, useEffect, useState } from "react";
import axiosInstance from "../../../configurations/axiosInstance/AxiosInstance";
import { Button, Space, Tag, Tooltip } from "antd";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Active } from "../../../components/active/index";
import { EditFilled, InfoCircleFilled } from "@ant-design/icons";
import BreadCom from "../../../components/breadCom/BreadCom";
import AddGallery from "../add";
import Loader from "../../../composants/loader/Loader";
import ViewTable from "../../../components/table/viewTable";
import { constantes, formatAuthor } from "../../../composants/utils/utils";
import { LoadingContext } from "../../../composants/loadingContext";
import { useRole, useTitle } from "../../../configurations/utils/Utils";
import { FormattedMessage } from "react-intl";
import * as Utils from '../../../composants/utils/utils';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileAudio, faVideo } from "@fortawesome/free-solid-svg-icons";
import UpdateGallery from "../update";

export default function ListGallery() {
    const { accessToken, droits } = useSelector(state => state.authUser);
    const { loading, setLoading } = useContext(LoadingContext)
    const [pageable, setPageable] = useState(constantes);
    const [url, setUrl] = useState('api/gallery/active?page=');
    const [data, setData] = useState([]);

    const nav = useNavigate();
    useRole([Utils.PERMISSIONS.GET_SLIDER.value]);
    useTitle('Liste des fichiers');
    const navigate = (link) => {
        nav(link);
    }

    const fetchGallery = () => {
        setLoading(true);
        axiosInstance(accessToken).get(url + 0).then(
            (result) => {
                if (result.data.totalElements == 0) {
                    setPageable(constantes);
                    setData([]);
                } else {
                    setData(result.data.content);
                    setPageable({
                        pageable: result.data.pageable,
                        last: result.data.last,
                        totalElements: result.data.totalElements,
                        totalPages: result.data.totalPages,
                        size: result.data.size,
                        number: result.data.number,
                        first: result.data.first,
                        numberOfElements: result.data.numberOfElements,
                        empty: result.data.empty
                    });
                }
                setLoading(false);
            }
        ).catch((error) => {
            setData([]);
            setPageable(constantes);
            setLoading(false);
        });
    }
    useEffect(() => {
        fetchGallery();
    }, []);

    const columns = [
        {
            accessor: "info",
        },
        {
            accessor: "type",
            className: "hidden lg:table-cell",
        },
        {
            accessor: "status",
            className: "hidden lg:table-cell",
        },
        {
            accessor: "action",
        },
    ];


    const renderRow = (item) => {
        const classHover = "border-b border-gray-200 even:bg-slate-50 text-sm hover:bg-lamaYellow";
        let status = null;
        if (item.active) {
            status = (
                <Tag color="green" >
                    <FormattedMessage id="enable" />
                </Tag>
            )
        } else {
            status = (
                <Tag color="volcano">
                    <FormattedMessage id="disable" />
                </Tag>
            )
        }
        return (
            <tr
                key={item.id}
                className={classHover}
                title={item.title}
            >
                <td className="p-4">
                    <div className="flex items-center gap-4">
                        {
                            (item.type === 'VIDEO') && (
                                <div className="flex items-center gap-2">
                                    <FontAwesomeIcon icon={faVideo} className="text-2xl text-blue-500 w-16 h-16 " />
                                    <p className="font-semibold">{item.title}</p>
                                </div>
                            )
                        }
                        {
                            (item.type === 'IMAGE') && (
                                <div className="flex items-center gap-2">
                                    <img className="w-16 h-16 object-cover rounded shadow" src={item.path} alt={item.title} />
                                    <p className="font-semibold">{item.title}</p>
                                </div>
                            )
                        }
                        {
                            (item.type === 'AUDIO') && (
                                <div className="flex items-center gap-2">
                                    <div className="relative">
                                        <FontAwesomeIcon icon={faFileAudio} className="text-2xl text-blue-500 w-16 h-16 " />
                                    </div>
                                    <p className="font-semibold">{item.title}</p>
                                </div>
                            )
                        }
                    </div>
                </td>
                <td className="hidden md:table-cell">{item.type}</td>
                <td className="hidden md:table-cell">{status}</td>
                <td>
                    <div className="flex items-center gap-2">
                        <Space>
                            {
                                droits.includes(Utils.PERMISSIONS.GET_SLIDER.value) && (
                                    <Tooltip title={"Detail du fichier"}>
                                        <Button type="primary" shape="circle" onClick={() => navigate('/admin/gallery/' + item.id)} >
                                            <i aria-hidden="true"><InfoCircleFilled /></i>
                                        </Button>
                                    </Tooltip>
                                )
                            }
                            {
                                droits.includes(Utils.PERMISSIONS.UPDATE_SLIDER.value) && (
                                    <>
                                        <UpdateGallery gallery={item} />
                                        <Active status={item.active} path={"api/gallery/active/"} id={item.id} />
                                    </>

                                )
                            }
                        </Space>
                    </div>
                </td>
            </tr>
        );
    }


    return (
        <>
            <BreadCom name={"Gallerie"} />
            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <section className="col-lg-12">
                            <div className="card card-primary" style={{ background: '#ffffff00' }}>
                                <div className="card-body">
                                    <div className="tab-content p-0">
                                        {
                                            loading ? <Loader /> : <>
                                                <ViewTable data={data} pageable={pageable} setData={setData} url={url} setPageable={setPageable} renderRow={renderRow} columns={columns} addBTN={droits.includes(Utils.PERMISSIONS.CREATE_SLIDER.value) && <AddGallery />} />
                                            </>
                                        }
                                    </div>
                                </div>
                            </div>
                        </section>

                    </div>
                </div>
            </section>
        </>
    );

}